import type { NavigateFunction } from 'react-router-dom';
import { isTenantDeactivatedApiError } from './apiErrorMessage';

export const TENANT_DEACTIVATED_PATH = '/tenant-deactivated';

let tenantAccessBlocked = false;
let appNavigate: NavigateFunction | null = null;
const listeners = new Set<() => void>();

export function getTenantAccessBlocked(): boolean {
  return tenantAccessBlocked;
}

export function subscribeTenantAccessBlocked(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function registerTenantAccessNavigate(
  navigate: NavigateFunction | null,
): void {
  appNavigate = navigate;
}

function navigateToTenantDeactivatedPage(): void {
  if (appNavigate) {
    appNavigate(TENANT_DEACTIVATED_PATH, { replace: true });
    return;
  }

  if (window.location.pathname !== TENANT_DEACTIVATED_PATH) {
    window.location.assign(TENANT_DEACTIVATED_PATH);
  }
}

export function markTenantAccessBlocked(): void {
  if (tenantAccessBlocked) {
    return;
  }

  tenantAccessBlocked = true;
  for (const listener of listeners) {
    listener();
  }
  navigateToTenantDeactivatedPage();
}

/**
 * If `error` is a tenant-deactivated API failure, marks access blocked and
 * navigates to the deactivated page. Returns true when handled.
 */
export async function handlePossibleTenantDeactivatedError(
  error: unknown,
): Promise<boolean> {
  if (tenantAccessBlocked) {
    return true;
  }

  if (!(await isTenantDeactivatedApiError(error))) {
    return false;
  }

  markTenantAccessBlocked();
  return true;
}
